import {
  HomeIcon,
  UsersIcon,
  CogIcon,
  ShoppingCartIcon,
  ChartBarIcon,
  FilmIcon,
  ChartPieIcon,
} from "@heroicons/react/24/outline";
import type { ComponentType, SVGProps } from "react";
import { lazy } from "react";

export interface RouteConfig {
  path: string;
  name: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  children?: RouteConfig[];
  component?: React.LazyExoticComponent<React.ComponentType>;
}

export const routes: RouteConfig[] = [
  {
    path: "/dashboard",
    name: "仪表盘",
    icon: HomeIcon,
  },
  {
    path: "/orders",
    name: "订单管理",
    icon: ShoppingCartIcon,
  },
  {
    path: "/tracks",
    name: "跑道列表",
    icon: FilmIcon,
  },
  {
    path: "/users",
    name: "用户管理",
    icon: UsersIcon,
  },
  {
    path: "/settings",
    name: "系统设置",
    icon: CogIcon,
  },
  {
    path: "/online-stats",
    name: "在线统计",
    icon: ChartBarIcon,
  },
  {
    path: "/workout-stats",
    name: "运动分析",
    icon: ChartPieIcon,
    component: lazy(() => import("../pages/WorkoutStats")),
  },
];
